import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private _isOnChatPage = signal<boolean>(false);
  private _isClient = signal<boolean>(false);
  private _newChatAssigned = signal<boolean>(false);
  private _unreadMessageCount = signal<number>(this.getStoredMessageCount());
  private _showMessageNotification = signal<boolean>(false);
  private _projectName = signal<string>('');
  private _messagePreview = signal<string>('');

  public readonly newChatAssigned = this._newChatAssigned.asReadonly();
  public readonly unreadMessageCount = this._unreadMessageCount.asReadonly();
  public readonly showMessageNotification = this._showMessageNotification.asReadonly();
  public readonly projectName = this._projectName.asReadonly();
  public readonly messagePreview = this._messagePreview.asReadonly();
  public readonly isClient = this._isClient.asReadonly();

  constructor() { }

  setOnChatPage(isOnChatPage: boolean) {
    this._isOnChatPage.set(isOnChatPage);
    if (isOnChatPage) {
      this.clearNewChatNotification();
    }
  }

  notifyNewChatAssigned() {
    if (!this._isOnChatPage()) {
      this._newChatAssigned.set(true);
    }
  }

  clearNewChatNotification() {
    this._newChatAssigned.set(false);
  }

  incrementUnreadMessageCount( messageContent: string , projectName: string, isClient: boolean) {
    if (!this._isOnChatPage()) {
      this._isClient.set(isClient);
      const newCount = this._unreadMessageCount() + 1;
      this._unreadMessageCount.set(newCount);
      this.setStoredMessageCount(newCount);
      this._projectName.set(projectName);
      this._messagePreview.set(messageContent.length > 10 ? messageContent.substring(0, 10) + '...' : messageContent);
      this._showMessageNotification.set(true);
    }
  }

  hideMessageNotification() {
    this._showMessageNotification.set(false);
  }

  resetUnreadMessageCount(): void {
    this._unreadMessageCount.set(0);
    this.setStoredMessageCount(0);
    this._showMessageNotification.set(false);
  }


  private setStoredMessageCount(count: number) {
    localStorage.setItem("unreadMessageCount", count.toString());
  }

  private getStoredMessageCount(): number {
    const storedCount = localStorage.getItem("unreadMessageCount");
    return Number(storedCount || 0);
  }
}
